import { render, staticRenderFns } from "./Pesquisa-estudantes-finalistas-por-ano.vue?vue&type=template&id=2df969f7&"
import script from "./Pesquisa-estudantes-finalistas-por-ano.vue?vue&type=script&lang=js&"
export * from "./Pesquisa-estudantes-finalistas-por-ano.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports